import styled from 'styled-components'
export const Wrapper = styled.div`
  padding-top: 43px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  .continueButton {
    margin-top: 50px;
  }
  .centerBg {
    text-align: center;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .top {
    margin-top: 50px;
  }
  .image {
    width: 20%;
  }
  .detail {
    display: flex;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    width: 100%;
    height: 150px;
    background: ${({ theme }) => theme.colors.grey};
    cursor: pointer;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .content {
    display: flex;
    flex-direction: column;
    width: 70%;
  }
  .interest {
    color: ${({ theme }) => theme.colors.TargetColor};
  }
  .info {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .center {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  p {
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    opacity: 0.8;
    margin-top: -15px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: -10px;
    }
  }
  h4 {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 24px;
    color: ${({ theme }) => theme.colors.NeutralBlack};
    opacity: 0.8;
  }
  .destination,
  .amount {
    margin-top: 30px;
  }
  .line {
    height: 3px;
    width: auto;
    background: ${({ theme }) => theme.colors.primary};
  }
  .css-b62m3t-container {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #858c94;
    box-sizing: border-box;
    border-radius: 8px;
    height: 60px;
  }
  .css-1s2u09g-control {
    height: 60px;
  }
  .css-14dclt2-Input {
    font-size: 14px;
    line-height: 24px;
    color: #6e7191;
    opacity: 0.8;
    padding-left: 16px;
  }
  .css-1okebmr-indicatorSeparator {
    background-color: transparent;
  }
  .css-1hb7zxy-IndicatorsContainer {
    border-bottom: 1px solid #858c94;
  }
  .css-319lph-ValueContainer {
    height: 60px;
    border-bottom: 1px solid #858c94;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const GeneralPlanInfoWrapper = styled.div`
  padding-top: 43px;
  margin: 0 10px;
`

export const PlanWithdrawBtnWrapper = styled.div`
  float: right;
  margin-right: 0px;
`

export const PlanNameContainer = styled.div`
  margin-top: 80px;
`

export const AmountAndProgressWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const UserCanWithdrawWrapper = styled.div`
  .btn-flex {
    display: flex;
    justify-content: space-around;
  }
`

export const PlanDetails = styled.div`
  .amount,
  .date,
  .frequency {
    display: flex;
    justify-content: space-between;
  }
`
export const MorePlanOptions = styled.div`
  .start_date p:nth-child(2) {
    font-weight: 500;
  }
`
